import { companyActionsPermissions } from './company/companyActionsPermissions';
import { diaryEntryActionsPermissions } from './diaryEntry/diaryEntryActionsPermissions';
import { EventBus } from '@/common/eventbus';
import { keywordActionsPermissions } from './keyword/keywordActionsPermissions';
import { partActionsPermissions } from './part/partActionsPermissions';
import { partCommentActionsPermissions } from './partComment/partCommentActionsPermissions';
import { personActionsPermissions } from './person/personActionsPermissions';
import { projectActionsPermissions } from './project/projectActionsPermissions';
import { stageActionsPermissions } from './stage/stageActionsPermissions';
import { todoItemActionsPermissions } from './todoItem/todoItemActionsPermissions';
import { todoTemplateActionsPermissions } from './todoItem/todoTemplateActionsPermissions';
import { inspectionActionsPermissions } from './inspection/inspectionActionsPermissions';
import { inspectionTemplateActionsPermissions } from './inspection/inspectionTemplateActionsPermissions';
import { undoActionsPermissions } from './undo/undoActionsPermissions';
import { userActionsPermissions } from './user/userActionsPermissions';
import companyFilesActionsPermissions from './companyFiles/permissions';
import * as Roles from '@/store/roles';

export const actionPermissions = {
  ...companyActionsPermissions,
  ...diaryEntryActionsPermissions,
  ...keywordActionsPermissions,
  ...partActionsPermissions,
  ...partCommentActionsPermissions,
  ...personActionsPermissions,
  ...projectActionsPermissions,
  ...stageActionsPermissions,
  ...todoItemActionsPermissions,
  ...todoTemplateActionsPermissions,
  ...inspectionActionsPermissions,
  ...inspectionTemplateActionsPermissions,
  ...undoActionsPermissions,
  ...userActionsPermissions,
  ...companyFilesActionsPermissions,
  'i18n/addLocale': [Roles.Any],
  delayedSelection: [Roles.Any],
  logAction: [Roles.Any],
  login: [Roles.Any],
  logout: [Roles.Any],
  'i18n/setLocale': [Roles.Any],
  setSyncStatus: [Roles.Any],
  setViewSetting: [Roles.Any],
  fetchS3DownloadLink: [Roles.Any],
};

// This no longer works so great because of https://github.com/vuejs/vuex/issues/1620
export const actionManager = (store) => {
  store.subscribeAction((action, state) => {
    if (!checkPermissions(action, state)) {
      EventBus.$emit('showMessageToUser', { message: 'Access Denied!', type: 'error', duration: 1000 });
      throw new Error('🚫 Access denied for ' + action.type + '🚫');
    }
  });
};

function isAdmin(role) {
  return role === Roles.Admin;
}

export const checkViewPermissions = (view, state) => {
  var role = state.loggedInPerson ? state.loggedInPerson.role : '';

  if (isAdmin(role)) {
    return true;
  }

  const permission = 'view' + view;
  if (!actionPermissions[permission]) {
    return true;
  }
  return actionPermissions[permission].includes(Roles.Any) || actionPermissions[permission].includes(role);
};

export const checkPermissions = (action, state) => {
  var role = state.loggedInPerson ? state.loggedInPerson.role : '';

  var actionName = action.type;
  if ((actionName.startsWith('undo') || actionName.startsWith('redo')) && actionName.length > 4) {
    actionName = actionName.charAt(4).toLowerCase() + actionName.slice(5);
  }

  var requiredRoles = actionPermissions[actionName];
  if (!requiredRoles) {
    EventBus.$emit('showMessageToUser', {
      message: 'Misconfigured permissions: ' + actionName,
      type: 'error',
      duration: 100000,
    });

    if (!isAdmin(role)) {
      throw new Error('⚠ Misconfigured permissions ⚠ ' + actionName);
    }
  }

  if (isAdmin(role)) {
    return true;
  }

  if (typeof requiredRoles === 'function') {
    return requiredRoles(role, action.payload);
  }

  if (requiredRoles.includes(Roles.Any)) {
    return true;
  }

  return requiredRoles.includes(role);
};



// WEBPACK FOOTER //
// ./src/store/actionManager.js